import React from 'react';
import styled from 'styled-components';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import PieChart from '../PieChart';
// import { getDimensionFullName } from '../constants';

export const ChartWrapper = styled.div`
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  width: 100%;
  position: relative;
  ${'' /* bug with polar lines on radar pdf print */}
  @media print {
    svg {
      g {
        line {
          opacity: 0;
        }
      }
    }
  }
`;

const VocationJuniorInterestGraphPage = ({
  user,
  background,
  number,
  electivos,
  campaign
}) => {
  // console.log({ electivos });
  const ELECTIVOS_NON_AVAILABLE = electivos
    ? electivos?.filter(e => !e.available)
    : [];
  // console.log({ ELECTIVOS_NON_AVAILABLE });
  // console.log({ campaign });
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>3.1. Grandes Áreas de Interés</h2>
          <p className='justified'>
            En la figura de más abajo puedes ver cuál es tu nivel de interés en
            cada una de las tres áreas. Las áreas con mayor porcentaje son las
            que te interesarían más:
          </p>
          <ChartWrapper>
            <PieChart user={user} electivos={electivos} />
          </ChartWrapper>
          {ELECTIVOS_NON_AVAILABLE.length > 0 && (
            <p className='justified' style={{ marginTop: '2rem' }}>
              Electivos de{' '}
              {ELECTIVOS_NON_AVAILABLE.reduce((acc, curr, index) => {
                let currItem = curr.name;
                // joiner, if penultimate, add ' y '
                if (index === ELECTIVOS_NON_AVAILABLE.length - 2) {
                  currItem += ' y ';
                } else if (index < ELECTIVOS_NON_AVAILABLE.length - 2) {
                  currItem += ', ';
                }
                return `${acc}${currItem}`;
              }, '')}{' '}
              no se encuentran disponibles actualmente para colegio
              {campaign?.organization && ` ${campaign?.organization}`}.
            </p>
          )}
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationJuniorInterestGraphPage;
